import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="balance-bill-drawer"
export default class extends Controller {
  static targets = ["check", "nextSteps", "otherClaims", "checksSection", "checksButtons", "formButtons"]

  connect() {
    const baseDelay = 1500

    this.checkTargets.forEach((check, index) => {
      this.prepare(check)
      // Add baseDelay before showing the first check, then baseDelay between each check
      const isLastCheck = index === this.checkTargets.length - 1
      setTimeout(() => {
        this.reveal(check)
        // Show the answer and form immediately after the last check reveals
        if (isLastCheck) {
          this.finishEvaluation()
        }
      }, baseDelay + (index * baseDelay))
    })
  }

  prepare(check) {
    const spinner = check.querySelector('[data-role="spinner"]')
    const successIcon = check.querySelector('[data-role="success-icon"]')
    const failureIcon = check.querySelector('[data-role="failure-icon"]')

    if (spinner) spinner.classList.remove("hidden")
    if (successIcon) successIcon.classList.add("hidden")
    if (failureIcon) failureIcon.classList.add("hidden")

    const message = check.querySelector('[data-role="message"]')
    if (message) {
      message.innerHTML = message.dataset.pendingText || "Evaluating..."
    }
  }

  reveal(check) {
    const result = check.dataset.result === "true"
    const spinner = check.querySelector('[data-role="spinner"]')
    const successIcon = check.querySelector('[data-role="success-icon"]')
    const failureIcon = check.querySelector('[data-role="failure-icon"]')
    const message = check.querySelector('[data-role="message"]')

    if (spinner) spinner.classList.add("hidden")

    if (result) {
      if (successIcon) successIcon.classList.remove("hidden")
      if (failureIcon) failureIcon.classList.add("hidden")
      if (message && message.dataset.successText) {
        message.innerHTML = message.dataset.successText
      }
    } else {
      if (failureIcon) failureIcon.classList.remove("hidden")
      if (successIcon) successIcon.classList.add("hidden")
      if (message && message.dataset.failureText) {
        message.innerHTML = message.dataset.failureText
      }
    }
  }

  finishEvaluation() {
    this.updateSummary()
    this.revealOtherClaims()
    this.revealNextSteps()
  }

  updateSummary() {
    const summary = this.element.querySelector('[data-role="summary"]')
    if (!summary) return

    const allPass = this.checkTargets.every(check => check.dataset.result === "true")
    const text = allPass ? summary.dataset.successText : summary.dataset.failureText
    if (text) summary.innerHTML = text
  }

  revealOtherClaims() {
    if (!this.hasOtherClaimsTarget) return

    const allPass = this.checkTargets.every(check => check.dataset.result === "true")

    // Only show the other claims block if all checks pass
    if (allPass) {
      this.otherClaimsTarget.classList.remove("hidden")
    }
  }

  revealNextSteps() {
    if (!this.hasNextStepsTarget) return

    const allPass = this.checkTargets.every(check => check.dataset.result === "true")

    // Only show the form if all checks pass
    if (allPass) {
      // Show the form (keep checks visible)
      this.nextStepsTarget.classList.remove("hidden")

      // Toggle buttons: hide checks buttons, show form buttons
      if (this.hasChecksButtonsTarget && this.hasFormButtonsTarget) {
        this.checksButtonsTarget.classList.add("hidden")
        this.formButtonsTarget.classList.remove("hidden")
      }
    }
  }
}
